<div class="buying-window-item">
  <div class="d-flex align-items-center justify-content-between">
    <span
      [innerHTML]="orderWindow.label | safeContent"
      class="buying-window--label"
    ></span>

    <div class="buying-window--badge" [ngClass]="badgeClass">
      {{ badgeLabel }}
    </div>
  </div>
  <div class="d-flex align-items-center mt-2">
    <div class="d-flex align-items-center gap-1 dates--label">
      <img src="/assets/img/icons/date.png" alt="Date" />
      <span>Buy Window Dates:</span>
    </div>
    <div>
      <span
        >{{ orderWindow.start_at | dateFormat: 'MMM D, YYYY ' }} -
        {{ orderWindow.end_at | dateFormat: 'MMM D, YYYY' }}</span
      >
    </div>
  </div>
  @if (hasMerketDates) {
    <div class="d-flex align-items-center mt-2 border-bottom">
      <div class="d-flex align-items-center gap-1 dates--label">
        <img src="/assets/img/icons/date.png" alt="Date" />
        <span>In Market Dates:</span>
      </div>
      <div>
        <span
          >{{ orderWindow.market_start_at | dateFormat: 'MMM YYYY ' }} -
          {{ orderWindow.market_end_at | dateFormat: 'MMM YYYY' }}</span
        >
      </div>
    </div>
  }
  <div class="mt-3">
    @if (canNavigate) {
      <button
        class="btn btn-link link-underline program--link"
        (click)="handleNavigate()"
      >
        {{ programLinkLabel }}
      </button>
    }
  </div>
</div>
